import { useNavigate } from 'react-router-dom'
import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useTranslation } from 'react-i18next'

export const ScreeningFollowUpCompleted = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.followUpCompletedPage')}
      screeningTitle={t('employee.screening.followUpCompletedTitle')}
      screeningDescription={t('employee.screening.followUpCompletedDescription')}
      buttonText={t('employee.screening.followUpCompletedButton')}
      onButtonClick={() => navigate('/portal/your-health/health-plan')}
    />
  )
}
